import { TFunction } from "i18next";
import type { TOptions } from "i18next/typescript/options";

/**
 * Can add postfix title with site name
 * Translate given title if necessary
 */
export function makeTitle(title: string|null|undefined, t: TFunction | null = null, translationOptions: TOptions = {} ): string {
  if (null === title || undefined === title) {
    return `CountLike.PRO`;
  }

  return (t === null ? title : t(title, translationOptions)); // I removed postfix
}